import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

const useSellTagTypesDict = () => {
    const { t } = useTwinTranslation()
    const tagTypesDict: TwinDictionary = {
        0: { name: t('quoteOrderTag', 'Etiqueta de presupuesto') },
        1: { name: t('sellTag', 'Etiqueta de venta') },
    }
    return tagTypesDict
}

export default useSellTagTypesDict